/**
 * Guards de rota para autenticação e validação
 */

import { authService } from '../services/auth.service';
import { router } from '../utils/router.util';
import { ROUTES } from '../constants/routes.constants';

/**
 * Verifica se o usuário está autenticado
 * Redireciona para login se não estiver
 */
export function requireAuth(): boolean {
  if (!authService.isAuthenticated()) {
    router.navigate(ROUTES.LOGIN);
    return false;
  }
  return true;
}

/**
 * Verifica se o usuário NÃO está autenticado
 * Redireciona para home se estiver autenticado
 */
export function requireGuest(): boolean {
  if (authService.isAuthenticated()) {
    router.navigate(ROUTES.HOME);
    return false;
  }
  return true;
}
